import { Link } from '@mui/material';
import Alert from '/@/components/bayer/alert';
import { _ } from '/@/locale';
import { reverse } from '/@/utils/router';

const ProbadorPlacaBanner = () => {
    const redirect = () => {
        window.open(
            reverse('library.LibraryDetail', {
                params: { slug: 'probador-placas-lt' },
            })
        );
    };

    return (
        <Alert severity='blue'>
            {_('Para más información, accedé al ')}
            <Link onClick={redirect} component='button' type='button' underline='always' color='secondary'>
                {_('Manual de probador de Placa ')}
            </Link>
            {_(', o bien consultá con tu distribuidor de confianza.')}
        </Alert>
    );
};

export default ProbadorPlacaBanner;
